var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"reserve"},[_c('img',{attrs:{"src":require("@/assets/change/newImg10.png")},on:{"click":_vm.clickHead}})]),_c('MobileReserveModels',{ref:"MobileReserveModels"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }